import { render, staticRenderFns } from "./StaffTypologyTable.vue?vue&type=template&id=44fc0f44&"
import script from "./StaffTypologyTable.vue?vue&type=script&lang=js&"
export * from "./StaffTypologyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports